import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.interface';
import {
    CreateRatingReasonDto,
    RatingReason,
    UpdateRatingReasonDto,
} from '../interfaces/rating-reason.interface';

@Injectable({
  providedIn: 'root',
})
export class RatingReasonsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = '/api/company/rating-reasons';

  getAll(): Observable<ApiResponse<RatingReason[]>> {
    return this.http.get<ApiResponse<RatingReason[]>>(this.baseUrl);
  }

  getById(id: number): Observable<ApiResponse<RatingReason>> {
    return this.http.get<ApiResponse<RatingReason>>(`${this.baseUrl}/${id}`);
  }

  create(dto: CreateRatingReasonDto): Observable<ApiResponse<RatingReason>> {
    return this.http.post<ApiResponse<RatingReason>>(this.baseUrl, dto);
  }

  update(id: number, dto: UpdateRatingReasonDto): Observable<ApiResponse<RatingReason>> {
    return this.http.put<ApiResponse<RatingReason>>(`${this.baseUrl}/${id}`, dto);
  }

  delete(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
